import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth',{
  state: () => ({
    authToken: "",
    isLogin: false,
    isFirstLogin : false,
    snsToken: {
      route: '',
      accessToken: '',
    },
  }),
  getters: {

  },
  actions: {
    // authenToken 설정
    saveAuthenToken(token: string) {
      if (!token) return;
      
      this.authToken = token;
      this.isLogin = true;
      this.isFirstLogin = true;
    },
    // authenToken 초기화
    clearAuthenToken() {
      this.authToken = '';
      this.isLogin = false;
    },
    setSnsToken(payload: { route: string; accessToken: string}) {
      this.snsToken.route = payload.route;
      this.snsToken.accessToken = payload.accessToken;
    },
    updateLogin(val: boolean) {
      this.isLogin = val;
    }
  },
});